import {DndSystemConfig, VisualConfig, ScrollConfig, CompatibilityConfig, DraggableConfig} from './types';
import {IsDeviceMobile} from "../utils/DeviceDetector";

export const DEFAULT_VISUAL_CONFIG: Required<VisualConfig> = {
	previewOpacity: 0.8,
	previewScale: 1.05,
	previewZIndex: 9999,
	indicatorZIndex: 9998,
	useDomClone: true
};

export const DEFAULT_SCROLL_CONFIG: Required<ScrollConfig> = {
	edgeThreshold: 50,
	scrollSpeed: 1,
	maxSpeed: 20,
	enabled: true,
	scrollableSelectors: [
		'body',             // Скролл страницы
		'html'              // Скролл страницы
	]
};

export const DEFAULT_COMPATIBILITY_CONFIG: Required<CompatibilityConfig> = {
	usePointerEvents: 'PointerEvent' in window,
	passiveEvents: true
};

export const DEFAULT_DND_CONFIG: DndSystemConfig = {
	visual: DEFAULT_VISUAL_CONFIG,
	scroll: DEFAULT_SCROLL_CONFIG,
	compatibility: DEFAULT_COMPATIBILITY_CONFIG
};

export const DndConstants = {
	MOVE_DETECTION_THRESHOLD_PX: 10, // Порог для детектирования любого движения
	SWIPE_DETECTION_THRESHOLD_PX: 25, // Минимальное расстояние для распознавания свайпа
	SCROLL_DETECTION_THRESHOLD : 10, // Порог для определения скролла
	SHORT_CLICK_TIMEOUT_MS : 150, // Максимальное время для короткого нажатия
	POST_SCROLL_BLOCK_DURATION_MS : 200, // Время блокировки драга после скролла

	TimeDesktopActivationMs: 150+1,
	TimeMobileActivationMs: 1000
} as const;

export const DRAG_DEFAULT_CONFIG : DraggableConfig = {
	activationDelay: IsDeviceMobile ? DndConstants.TimeMobileActivationMs : DndConstants.TimeDesktopActivationMs,
	movementThreshold: 5,
	preventScroll: true,
	disabled: false
} as const;

